import React from 'react'
import { Grid } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { dataCatalog } from '../../../../api/coreData'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import DatasourceLayout from './shared/DatasourceLayout'

const SEARCH_VALUE = {
  filters: {
    type: 'aiFeature'
  },
  includes: {
    namespace: true
  }
}

function CatalogAiFeatures () {
  const { data, isLoading } = dataCatalog.useSearchCatalogDataSources(SEARCH_VALUE)

  if (isLoading) {
    return (
      <FadeIn key='loading'>
        <Loading />
      </FadeIn>
    )
  }

  if (!(data?.total || 0)) {
    return (
      <FadeIn key='no_data'>
        <EmptySection
          title='No AI Features'
          description='AI Features are added by the platform team. Enable them here as they become available.'
        />
      </FadeIn>
    )
  }

  return (
    <FadeIn key='ai-features'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DatasourceLayout items={data?.data || []} />
        </Grid>
      </Grid>
    </FadeIn>
  )
}

export default CatalogAiFeatures
